import { useMemo, useState } from "react";

import useEvent from "@/hooks/useEvent";

const useCabinsColorIdentify = () => {
  const [cabinsColorIdentifyVisible, setCabinsColorIdentifyVisible] = useState(() => {
    return !localStorage.getItem("__CabinsColorIdentifyVisible__");
  });

  const hideColorIdentify = useEvent(() => {
    setCabinsColorIdentifyVisible(false);
    localStorage.setItem("__CabinsColorIdentifyVisible__", "1");
  });

  return useMemo(() => {
    return {
      cabinsColorIdentifyVisible,
      hideColorIdentify,
    };
  }, [cabinsColorIdentifyVisible, hideColorIdentify]);
};

export default useCabinsColorIdentify;
